<template>

  <div id="Pagination" class="mb-4">
    <!-- Div para mostrar el texto personalizado del total -->
    <div style="display: flex; align-items: center;">

      <div v-if="showPagination" class="pagination-total mt-1">
        <span class="start">{{ start }}</span> {{$t('a')}}
        <span class="end">{{ end }}</span> {{$t('de')}}
        <span class="total">{{ total }}</span>
      </div>

      <el-pagination
          v-model:currentPage="localPage"
          v-model:page-size="localSize"
          :page-sizes="[5, 10, 20, 25, 50]"
          :layout="layout"
          :pager-count="5"
          :total="total"
          class="ms-3"
          @current-change="handlePaginationCurrentChange"
          background
      >
      </el-pagination>
    </div>
  </div>

</template>

<script>
import { computed, onMounted, onUnmounted, ref, watch } from "vue"

export default {

  name: "PaginationTable",
  props: {
    showPagination: {},
    currentPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    handleCurrentChange: {
      default: null,
    },
  },
  setup(props, ctx) {
    // Local refs to store the pagination values
    const localPage = ref(props.currentPage);
    const localSize = ref(props.pageSize);
    const layout = ref("prev, pager, next, sizes");

    // Watch for changes in props and sync with local refs
    watch(() => props.currentPage, (newVal) => {
      localPage.value = newVal;
    });
    watch(() => props.pageSize, (newVal) => {
      localSize.value = newVal;
    });

    const handlePaginationCurrentChange = (val) => {
      ctx.emit('update:currentPage', val);
      if (props.handleCurrentChange) props.handleCurrentChange(val);
    };

    const updateLayout = () => {
      if (window.innerWidth <= 991) {
        layout.value = "prev, next";
      } else {
        layout.value = "prev, pager, next";
      }
    };

    // Calculate pagination text (start, end)
    const start = computed(() => (localPage.value - 1) * localSize.value + 1);
    const end = computed(() => Math.min(localPage.value * localSize.value, props.total));

    // Watch for window resize events
    window.addEventListener('resize', updateLayout);

    // Initial check
    onMounted(() => {
      updateLayout();
    });

    // Cleanup on unmounted
    onUnmounted(() => {
      window.removeEventListener('resize', updateLayout);
    });

    return {
      localPage,
      localSize,
      layout,
      start,
      end,
      handlePaginationCurrentChange,
    };
  }
};
</script>

<style scoped>
#Pagination {
  --el-color-primary: #21644b;
}

.pagination-total {
  margin-right: 10px; /* Espacio entre el texto y el el-pagination */
  font-size: 14px;
  color: #21644b;
}

.pagination-total .start,
.pagination-total .end,
.pagination-total .total {
  font-weight: bold;
  color: #21644b; /* Verde */
}
</style>
